import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { useController } from "@rest-hooks/react";

import PageElementResource from 'resources/Profile/PageElementResource';

import Embeds from "./Embeds";
import Calendar from "./Calendar";
import Text from "./Text";

import Provider from "containers/student/Settings/ConnectedAccounts/Accounts/Provider";

import useElementStatsController from "utils/profile/useElementStatController";
import { getSocialPlatformLogo, isSocialElement, isEmbeddedElement } from "utils/pageElements/helpers";

import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from "@mui/material/ListItemText";

const Content = ({ element, profile, organizationSlug, preview }) => {

    const [openConnectAccount, setOpenConnectAccount] = useState(false);

    const {fetch} = useController();
    const {createStat} = useElementStatsController(organizationSlug);

    const history = useHistory();

    const {content, filtered_content, element_type, image_url, link_title, require_telegram, require_whatsapp, id, settings} = element;

    const displayContent = preview ? filtered_content : content;

    const isTitle = element_type === "title";
    const isText = element_type === "text";
    const isLink = element_type === "link";
    const isEmail = element_type === "email";
    const isSocial = isSocialElement(element_type);
    const isEmbed = isEmbeddedElement(element_type);
    const isCalendar = element_type === "calendar";

    const action = () => {
      if (profile) createStat(id);
      if (require_telegram || require_whatsapp) {
        setOpenConnectAccount(true);
      } else if (isLink || isSocial) {
        const url = isEmail ? null : new URL(displayContent);
        const isInternalLink = isEmail ? false : url.hostname === window.location.hostname;
        if (isInternalLink){
          history.push(url.pathname + url.search);
        } else {
          const link = isEmail ? `mailto:${displayContent}` : displayContent;
          window.open(link, "_blank");
        }
      }
    };

    const socialElementIcon = isSocial && getSocialPlatformLogo(element_type);

    const handleConnectAccount = async () => {
      window.open(displayContent, "_blank");
      await fetch(PageElementResource.detail(), {organization_slug: organizationSlug, id: 1})

      setOpenConnectAccount(false);
    };

    return (
    <>
      {(isTitle) && (
        <ListItemText 
          sx={{wordWrap: "break-word", margin: profile ? "20px 0px" : "0px 20px 0px 0px"}} 
          primary={displayContent} 
          className={element_type}/>
      )}

      {isText && (
        <Text content={displayContent} profile={profile} />
      )}

      {isCalendar && (
        profile ? (
          <Calendar
            view={settings?.view}
            hidePrice={settings?.hide_price}
            hideLocation={settings?.hide_location}
            organizationSlug={organizationSlug}
          />
        ) : (
          <ListItemText
            sx={{wordWrap: "break-word", padding: "0 10px"}}
            primary={`🗓️ Calendar showing next ${settings?.number_of_events} events`}
          />
        )
      )}

      {isLink && (
        <ListItemButton
          onClick={action}
          disableRipple
          disableGutters
          className='list-item-button'
        >
          {image_url && (
            <ListItemAvatar className="image-container">
              <img className="image" src={image_url} />
            </ListItemAvatar>
          )}
          <ListItemText sx={{wordWrap: "break-word"}}  primary={link_title} />
        </ListItemButton>
      )}

      {isSocial && (
        <ListItemButton
          onClick={action}
          disableRipple
          disableGutters
          className='list-item-button'
        >
          <ListItemAvatar className="image-container">
            <img className="icon" src={socialElementIcon} />
          </ListItemAvatar>
          <ListItemText sx={{wordWrap: "break-word"}} primary={displayContent} />
        </ListItemButton>
      )}

      <Provider open={openConnectAccount && (require_telegram || require_whatsapp)}
                onClose={() => setOpenConnectAccount(false)}
                onSuccess={handleConnectAccount}
                provider={ require_telegram ? "telegram" : "whatsapp"}
                showJoin={require_telegram} />

      {isEmbed && (
        <Embeds profile={profile} content={displayContent} element_type={element_type}/>
      )}

    </>
  );
};

Content.propTypes = {
  element: PropTypes.object,
  profile: PropTypes.bool,
  organizationSlug: PropTypes.string,
  preview: PropTypes.bool
};

export default Content;
